// extracted by mini-css-extract-plugin
module.exports = {"slider":"Swiper_slider__37ujs","control":"Swiper_control__2csGM","previous":"Swiper_previous__3oakM","next":"Swiper_next__1OD4u"};